import marqii from '@/assets/images/marqii.svg'
import { Avatar } from '@/components/Avatar'
import { ConditionalComponent } from '@/components/ConditionalComponent/ConditionalComponent'
import { Dropdown } from '@/components/Dropdown'
import { Image } from '@/components/Image'
import { ImpersonatingBanner } from '@/components/ImpersonatingBanner'
import { Space } from '@/components/Space'
import { useCognitoAuth } from '@/contexts/cognitoAuthContext'
import { DashboardExperiments } from '@/experiments'
import { PATHS } from '@/routes/PATHS'
import { usePremiumFeaturesStatus } from '@/stores/permissions/premiumFeatures'
import { LogoutOutlined, UserOutlined } from '@ant-design/icons'
import { useFlag } from '@unleash/proxy-client-react'
import { Layout } from 'antd'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router'
import { BeamerWidget } from './Beamer/BeamerWidget'
import styles from './styles.scss'

enum ActionType {
  userProfile = 'userProfile',
  logout = 'logout',
}

export const HEADER_TEST_ID = 'header-test-id'
export const USER_PROFILE_ICON_TEST_ID = 'user-profile-icon-test-id'

export function Header() {
  const { logout, userAttributes } = useCognitoAuth()

  const { t } = useTranslation()
  const premiumFeaturesStatus = usePremiumFeaturesStatus()

  const showBeamerChangeLog = useFlag(DashboardExperiments.showBeamerChangelog)
  const shouldBlockAccount = premiumFeaturesStatus && premiumFeaturesStatus === 'SUSPENDED'

  const shouldShowBeamer = showBeamerChangeLog && !shouldBlockAccount

  const userName = userAttributes
    ? `${userAttributes.given_name} ${userAttributes.family_name}`
    : 'User Name'

  const dropdownItems = useMemo(() => {
    return [
      {
        key: ActionType.userProfile,
        icon: <UserOutlined data-testid={USER_PROFILE_ICON_TEST_ID} />,
        label: <Link to={PATHS.userProfilePage}>{t('components.navbar.userProfile')}</Link>,
      },
      {
        key: ActionType.logout,
        label: t('components.navbar.logout'),
        icon: <LogoutOutlined />,
        onClick: logout,
        danger: true,
      },
    ]
  }, [t, logout])

  return (
    <div>
      <ImpersonatingBanner />

      <Layout.Header data-testid={HEADER_TEST_ID} className={styles.header}>
        <Link to={PATHS.homePage}>
          <Space align="center">
            <Image src={marqii} width="100px" />
          </Space>
        </Link>
        <ConditionalComponent condition={shouldShowBeamer}>
          <BeamerWidget className={styles.beamerWidget} />
        </ConditionalComponent>
        <div>
          <Avatar size={30}>{userName.charAt(0)}</Avatar>
          <Dropdown
            className={styles.userName}
            type="link"
            label={userName}
            placement="bottomRight"
            items={dropdownItems}
          />
        </div>
      </Layout.Header>
    </div>
  )
}
